import React from "react";
import { Box, BoxProps, TableContainer, TableProps as MuiTableProps } from "@mui/material";

import { BaseTable } from "./Table.styles";

export type TableProps = MuiTableProps & {
  containerProps?: BoxProps;
  variant?: "ag-grid-compact" | "ag-grid-standard" | "ag-grid-compact-scrollable";
  maxHeight?: number;
} & (
    | {
        variant?: "ag-grid-compact" | "ag-grid-standard";
        maxHeight?: never;
      }
    | {
        variant?: "ag-grid-compact-scrollable";
        maxHeight?: number;
      }
  );

const Table: React.FC<TableProps> = ({ variant, maxHeight, containerProps, ...props }: TableProps) => {
  if (variant === "ag-grid-compact" || variant === "ag-grid-standard")
    return (
      <TableContainer component={Box} sx={{ borderRadius: 1, border: "1px solid #ddddde", overflow: "hidden" }} {...containerProps}>
        <BaseTable {...props} variant={variant} />
      </TableContainer>
    );

  if (variant === "ag-grid-compact-scrollable")
    return (
      <TableContainer component={Box} sx={{ borderRadius: 1, border: "1px solid #ddddde", maxHeight, overflowY: "scroll" }} {...containerProps}>
        <BaseTable {...props} stickyHeader variant="ag-grid-compact" />
      </TableContainer>
    );

  return <BaseTable {...props} variant={variant} />;
};

export default Table;
